<mat-tab-group  [selectedIndex]='index'  (selectedTabChange)="tabChanged($event)">
    <mat-tab label="Délégués">
      <ng-template mat-tab-label>
        <img width="30" src="assets/img/icontab/delegate.png" alt="" srcset="">
 
        Matériel spécifique
      </ng-template>
      
      <app-materiel  [index]="index"></app-materiel>
    </mat-tab>
    <mat-tab label="Publicité">
        <ng-template mat-tab-label>
          <img width="30" src="assets/img/icontab/delegate.png" alt="" srcset="">
   
          Publicité
        </ng-template>
        
        <app-publicite  [index]="index"></app-publicite>
      </mat-tab>
   
      <mat-tab label="Liste des Stands">
        <ng-template mat-tab-label>
          <img width="30" src="assets/img/icontab/delegate.png" alt="" srcset="">
   
          Liste des Stands
        </ng-template>
        
        <app-stands  [index]="index"></app-stands>
      </mat-tab>

      <mat-tab label="Liste des Stands">
        <ng-template mat-tab-label>
          <img width="30" src="assets/img/icontab/delegate.png" alt="" srcset="">
   
          Signalétique
        </ng-template>
        
        <app-signalitique  [index]="index"></app-signalitique>
      </mat-tab>


      <mat-tab label="Liste des Stands">
        <ng-template mat-tab-label>
          <img width="30" src="assets/img/icontab/delegate.png" alt="" srcset="">
   
          Hotels
        </ng-template>
        
        <app-hotels  [index]="index"></app-hotels>
      </mat-tab>
      <mat-tab label="Liste des Stands">
        <ng-template mat-tab-label>
          <img width="30" src="assets/img/icontab/delegate.png" alt="" srcset="">
   
          Constructeurs de stands
        </ng-template>
        
        <app-constructeurs  [index]="index"></app-constructeurs>
      </mat-tab>
  </mat-tab-group>
